export default {
  namespaced: true,
  
  state: () => ({
    fontFamily: 'primary',       // primary or secondary
    fontSize: 'base',            // xs, sm, base, lg, xl, 2xl, 3xl, 4xl
    fontWeight: 'regular',       // light, regular, medium, semibold, bold
    lineHeight: 'normal',        // tight, normal, relaxed
    letterSpacing: 'normal',     // tight, normal, wide
    textColor: 'primary',        // primary, secondary, tertiary, light, error, success
  }),
  
  mutations: {
    SET_FONT_FAMILY(state, family) {
      state.fontFamily = family;
    },
    
    SET_FONT_SIZE(state, size) {
      state.fontSize = size;
    },
    
    SET_FONT_WEIGHT(state, weight) {
      state.fontWeight = weight;
    },
    
    SET_LINE_HEIGHT(state, lineHeight) {
      state.lineHeight = lineHeight;
    },
    
    SET_LETTER_SPACING(state, spacing) {
      state.letterSpacing = spacing;
    },
    
    SET_TEXT_COLOR(state, color) {
      state.textColor = color;
    }
  },
  
  getters: {
    fontFamilyClass: state => `font-${state.fontFamily}`,
    
    fontSizeClass: state => `text-${state.fontSize}`,
    
    fontWeightClass: state => `font-${state.fontWeight}`,
    
    lineHeightClass: state => `leading-${state.lineHeight}`,
    
    letterSpacingClass: state => `tracking-${state.letterSpacing}`,
    
    textColorClass: state => `text-${state.textColor}-color`,
    
    combinedClasses: state => {
      return [
        `font-${state.fontFamily}`,
        `text-${state.fontSize}`,
        `font-${state.fontWeight}`,
        `leading-${state.lineHeight}`,
        `tracking-${state.letterSpacing}`,
        `text-${state.textColor}-color`
      ].join(' ');
    }
  },
  
  actions: {
    setFontStyle({ commit }, { 
      family = null, 
      size = null, 
      weight = null, 
      lineHeight = null, 
      letterSpacing = null, 
      textColor = null 
    }) {
      if (family) commit('SET_FONT_FAMILY', family);
      if (size) commit('SET_FONT_SIZE', size);
      if (weight) commit('SET_FONT_WEIGHT', weight);
      if (lineHeight) commit('SET_LINE_HEIGHT', lineHeight);
      if (letterSpacing) commit('SET_LETTER_SPACING', letterSpacing);
      if (textColor) commit('SET_TEXT_COLOR', textColor);
    }
  }
};